<template>
  <el-cascader
    ref="addressCascader"
    v-model="value"
    :props="props"
    :placeholder="placeholder"
    @change="handleChange"
  ></el-cascader>
</template>

<script>
import {
  getNewProvince,
  getNewCitiesByProvince,
  getNewRegionsByCity,
  getNewStreetByRegion,
} from '@fetch/address';

function resetData(data = [], level) {
  if (data && !data.data) {
    return []
  };
  return data.data.map((item) => {
    return {
      value: item.id,
      label: window.CheckCN() ? item.nameCh : item.nameEn,
      leaf: level >= 3,
      df_name: item.id + '-' + (window.CheckCN() ? item.nameCh : item.nameEn),
      ...item,
    };
  });
}

export default {
  name: 'AddressCascaderNew',
  props: {
    areaValue: Array, // 默认回显的省市区、街道
    areaList: {
      type: Array,
      default: () => [],
    }, // 过滤省市区列表（只可选择某一省、市下的区和街道）[provinceId, cityId]
    areaValueEN: {
      type: Array,
      default: () => [],
    }, // 过滤省市区列表（只可选择某一省、市下的区和街道）[provinceId, cityId]
    placeholder: String,
  },
  data() {
    const _this = this;
    return {
      value: [], //回显的值
      props: {
        lazy: true,
        value: 'df_name',
        lazyLoad(node, resolve) {
          const { level, data } = node;
          let nodes = [];

          switch (level) {
          case 0: // 省数据
            getNewProvince({}).then((res) => {
              nodes = resetData(res, level);
              if (_this.areaList.length > 0) {
                nodes = nodes.filter((item) => item.id === _this.areaList[0]);
              }
              resolve(nodes);
            });
            break;
          case 1: // value 省下城市数据
            getNewCitiesByProvince({ districtId: data.id }).then((res) => {
              nodes = resetData(res, level);
              if (_this.areaList.length > 0) {
                nodes = nodes.filter((item) => item.id === _this.areaList[1]);
              }
              resolve(nodes);
            });
            break;
          case 2: // value 市下区域数据
            getNewRegionsByCity({ cityId: data.id }).then((res) => {
              nodes = resetData(res, level);
              resolve(nodes);
            });
            break;
          case 3: // value 区下街道
            getNewStreetByRegion({ regionId: data.id }).then((res) => {
              nodes = resetData(res, level);
              resolve(nodes);
            });
            break;
          default:
            resolve([]);
          }
        },
      },
    };
  },
  mounted() {
    this.value =window.CheckCN() ?  this.areaValue|| [] : this.areaValueEN|| [] ;
  },
  methods: {
    handleChange(value = []) {
      // console.log(this.value, value);
      this.$emit('onSetCascaderData', {
        provinceId: this.transformValue(value[0]),
        cityId: this.transformValue(value[1]),
        regionId: this.transformValue(value[2]),
        streetId: this.transformValue(value[3]),
      });
    },
    transformValue(value) {
      if (value) {
        return value.split('-')[0];
      }
    },
  },
};
</script>
